import React from "react";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { IconButton, Tooltip } from "@material-ui/core";
import { Delete, Notifications, Visibility } from "@material-ui/icons";

export const getColumns = () => [
  {
    name: "id",
    label: "Id",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: "title",
    label: "Title",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: "file_type",
    label: "File Type",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) => {
        let src;
        let type = value.toLowerCase();

        if (type === "audio")
          src = `${toAbsoluteUrl("/media/assets/audio-icon.png")}`;
        if (type === "text" || type === "html")
          src = `${toAbsoluteUrl("/media/assets/text-icon.png")}`;
        if (type === "link")
          src = `${toAbsoluteUrl("/media/assets/link-icon.png")}`;
        if (type === "video")
          src = `${toAbsoluteUrl("/media/assets/video-icon.png")}`;
        if (type === "pdf")
          src = `${toAbsoluteUrl("/media/assets/pdf-icon.png")}`;
        if (type === "document")
          src = `${toAbsoluteUrl("/media/assets/docx-icon.png")}`;
        if (type === "image")
          src = `${toAbsoluteUrl("/media/assets/image.png")}`;
        if (type === "tip") src = `${toAbsoluteUrl("/media/assets/tip.jpg")}`;

        return (
          src && (
            <img
              width="40px"
              height="40px"
              src={src}
              alt="file_type"
              style={{ cursor: "pointer" }}
            />
          )
        );
      },
    },
  },
];

export const getActionColumns = ({
  openDialog,
  setHtmlContent,
  handleOpenNotify,
  deleteCont,
}) => [
  {
    name: "resource_url",
    label: "Actions",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value, meta, updater) => {
        return (
          <div className="d-flex">
            <Tooltip title="Edit Content" placement="top">
              <IconButton
                id={`edit_content_btn_${meta.rowData[0]}`}
                size="small"
                aria-label="Edit Content"
                onClick={() => openDialog("editing", meta.rowData[0])}
              >
                <i className="fas fa-edit text-primary" />
              </IconButton>
            </Tooltip>

            <Tooltip title="View Content" placement="top">
              {meta.rowData[2] ? (
                meta.rowData[2] === "html" ? (
                  <IconButton
                    id={`view_content_btn_${meta.rowData[0]}`}
                    name="content"
                    size="small"
                    aria-label="View Content"
                    onClick={() => setHtmlContent(value)}
                  >
                    <Visibility fontSize="small" />
                  </IconButton>
                ) : (
                  <a
                    id={`view_content_btn_${meta.rowData[0]}`}
                    href={value}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-light btn-hover-success text-success btn-sm mx-3"
                    name="content"
                  >
                    <Visibility fontSize="small" />
                  </a>
                )
              ) : (
                <button
                  id={`view_content_btn_${meta.rowData[0]}`}
                  className="btn btn-light btn-hover-success text-success btn-sm mx-3"
                  disabled
                >
                  <Visibility fontSize="small" />
                </button>
              )}
            </Tooltip>
            <Tooltip title="Send notification" placement="top">
              <IconButton
                id={`notification_content_btn_${meta.rowData[0]}`}
                size="small"
                aria-label="Send notification"
                onClick={() => handleOpenNotify(meta.rowData[0])}
              >
                <Notifications />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete Content" placement="top">
              <IconButton
                id={`delete_content_btn_${meta.rowData[0]}`}
                size="small"
                aria-label="Delete Content"
                onClick={() => deleteCont(meta.rowData[0])}
              >
                <Delete />
              </IconButton>
            </Tooltip>
          </div>
        );
      },
    },
  },
];
